import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale"; // 한국어 locale 추가
import { registerLocale } from "react-datepicker";
import ReactQuillModul from "./ReactQuillModul";

registerLocale("ko", ko); // 한국어 locale 등록

const Admin_NView = () => {
  const { idx } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [, setNewsList] = useState([]); //  목록 상태 추가
  const navigate = useNavigate(); // 삭제 후 목록으로 리다이렉트할 때 사용
  
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    const fetchNews = async () => {
      try {
        const response = await axios.get("/boards");
        const newses = response.data;
        const selectNews = newses.find((news) => news.idx === parseInt(idx));
        setNewsItem(selectNews);
        setStartDate(new Date(selectNews.bdStart));
        setEndDate(new Date(selectNews.bdEnd));
      } catch (error) {
        console.error("Error fetching newses:", error);
      }
    };

    fetchNews();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, [idx]);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  // 삭제 요청을 처리하는 함수
  const handleDelete = async () => {
    // 사용자가 정말로 삭제할 것인지 확인하는 창
    if (window.confirm("삭제하시겠습니까?")) {
      try {
        const response = await axios.delete(`/board_delete/${newsItem.idx}`);
        if (response.status === 200) {
          alert("삭제되었습니다.");

          // 삭제 후 배너 목록을 갱신
          setNewsList((prevList) =>
            prevList.filter((news) => news.idx !== newsItem.idx)
          );

          // 삭제 후 목록 페이지로 이동
          navigate("/admin/board/notice");
        }
      } catch (error) {
        console.error("삭제 실패:", error);
        alert("삭제에 실패했습니다.");
      }
    }
  };

  if (!newsItem) {
    return <div>로딩 중...</div>;
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setNewsItem((prev) => ({
      ...prev,
      bdStart: date.toISOString().split("T")[0],
    }));
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setNewsItem((prev) => ({
      ...prev,
      bdEnd: date.toISOString().split("T")[0],
    }));
  };

  const hoursOptions = Array.from({ length: 24 }, (_, i) => (
    <option key={i} value={i < 10 ? `0${i}` : i}>
      {i < 10 ? `0${i}` : i}
    </option>
  ));

  const minutesOptions = Array.from({ length: 6 }, (_, i) => (
    <option key={i} value={i * 10}>
      {i * 10 < 10 ? `0${i * 10}` : i * 10}
    </option>
  ));

  const handleUpdate = async () => {
    // 수정 확인 알림창
    const isConfirmed = window.confirm("수정하시겠습니까?");

    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 폼 제출을 중단
    }

    const formData = new FormData();
    formData.append("memId", localStorage.getItem("adminId"));
    formData.append("name", localStorage.getItem("adminName"));
    formData.append("title", newsItem.title);
    formData.append("content", newsItem.content);
    formData.append("notice", newsItem.notice);
    formData.append("bdStart", newsItem.bdStart);
    formData.append("bdShour", newsItem.bdShour);
    formData.append("bdSmin", newsItem.bdSmin);
    formData.append("bdEnd", newsItem.bdEnd);
    formData.append("bdEhour", newsItem.bdEhour);
    formData.append("bdEmin", newsItem.bdEmin);
    // 요청 전에 URL을 로그로 확인
    console.log(`/bp_update/${newsItem.idx}`);

    try {
      const response = await axios.put(
        `/board_update/${newsItem.idx}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200) {
        alert("소식이 수정되었습니다.");
        window.location.href = "/admin/board/notice";
      }
    } catch (error) {
      console.error("소식 수정 실패:", error);
      alert("소식 수정에 실패했습니다.");
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_view">
        <div className="path-sec">
          HOME &gt; <span className="menu1">게시판 관리</span> &gt;
          <span className="menu2"> 아소비소식 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">게시판 관리</h3>
				<ul className="snb_list">
				  {permissions.notice && (
				    <li className="cur">
				      <a href="/admin/board/notice">아소비소식 관리</a>
				    </li>
				  )}
				  {permissions.event && (
				    <li>
				      <a href="/admin/board/event">아소비이벤트 관리</a>
				    </li>
				  )}
				  {permissions.social && (
				    <li>
				      <a href="/admin/board/social">아소비 소셜 관리</a>
				    </li>
				  )}
				  {permissions.magazine && (
				    <li>
				      <a href="/admin/board/magazine">아소비 꿀지 관리</a>
				    </li>
				  )}
				</ul>
              </div>
            </td>
            <td>
              <div className="bx-top">아소비 소식 상세</div>
              <form id="editform">
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <tr>
                        <th>메인타이틀</th>
                        <td>
                          <input
                            name="titie"
                            value={newsItem.title}
                            type="text"
                            placeholder="여기에 제목을 입력하세요"
                            onChange={(e) =>
                              setNewsItem({
                                ...newsItem,
                                title: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>소식 타입</th>
                        <td>
                          <label>
                            <input
                              type="radio"
                              name="use_yn"
                              value="Y"
                              checked={newsItem.notice === "Y"}
                              onChange={() =>
                                setNewsItem({ ...newsItem, useYn: "Y" })
                              }
                            />
                            asobi_notice
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="use_yn"
                              value="N"
                              checked={newsItem.notice === "N"}
                              onChange={() =>
                                setNewsItem({ ...newsItem, useYn: "N" })
                              }
                            />
                            asobi_News
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <th>게시 일자</th>
                        <td>
                          <div className="datepicker-wrapper">
                            <DatePicker
                              selected={startDate}
                              onChange={handleStartDateChange}
                              className="inputtext required"
                              dateFormat="yyyy-MM-dd"
                              locale="ko"
                              showYearDropdown
                              showMonthDropdown
                              yearDropdownItemNumber={15}
                              scrollableYearDropdown
                              showIcon
                              icon={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 48 48"
                                >
                                  <mask id="ipSApplication0">
                                    <g
                                      fill="none"
                                      stroke="#fff"
                                      strokeLinejoin="round"
                                      strokeWidth="4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        d="M40.04 22v20h-32V22"
                                      ></path>
                                      <path
                                        fill="#fff"
                                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                      ></path>
                                    </g>
                                  </mask>
                                  <path
                                    fill="currentColor"
                                    d="M0 0h48v48H0z"
                                    mask="url(#ipSApplication0)"
                                  ></path>
                                </svg>
                              }
                            />
                            <select
                              name="bdShour"
                              id="bdShour"
                              value={newsItem.bdShour}
                              onChange={(e) =>
                                setNewsItem({
                                  ...newsItem,
                                  bdShour: e.target.value,
                                })
                              }
                            >
                              {hoursOptions}
                            </select>
                            시
                            <select
                              name="bdSmin"
                              id="bdSmin"
                              value={newsItem.bdSmin}
                              onChange={(e) =>
                                setNewsItem({
                                  ...newsItem,
                                  bdSmin: e.target.value,
                                })
                              }
                            >
                              {minutesOptions}
                            </select>
                            분 ~{" "}
                            <DatePicker
                              selected={endDate}
                              onChange={handleEndDateChange}
                              className="inputtext required"
                              dateFormat="yyyy-MM-dd"
                              locale="ko"
                              showYearDropdown
                              showMonthDropdown
                              yearDropdownItemNumber={15}
                              scrollableYearDropdown
                              showIcon
                              icon={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 48 48"
                                >
                                  <mask id="ipSApplication0">
                                    <g
                                      fill="none"
                                      stroke="#fff"
                                      strokeLinejoin="round"
                                      strokeWidth="4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        d="M40.04 22v20h-32V22"
                                      ></path>
                                      <path
                                        fill="#fff"
                                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                      ></path>
                                    </g>
                                  </mask>
                                  <path
                                    fill="currentColor"
                                    d="M0 0h48v48H0z"
                                    mask="url(#ipSApplication0)"
                                  ></path>
                                </svg>
                              }
                            />
                            <select
                              name="bdEhour"
                              id="bdEhour"
                              value={newsItem.bdEhour}
                              onChange={(e) =>
                                setNewsItem({
                                  ...newsItem,
                                  bdEhour: e.target.value,
                                })
                              }
                            >
                              {hoursOptions}
                            </select>
                            시
                            <select
                              name="bdEmin"
                              id="bdEmin"
                              value={newsItem.bdEmin}
                              onChange={(e) =>
                                setNewsItem({
                                  ...newsItem,
                                  bdEmin: e.target.value,
                                })
                              }
                            >
                              {minutesOptions}
                            </select>
                            분
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>내용 입력</th>
                        <td>
                          <ReactQuillModul
                            editorValue={newsItem.content} // newsItem.content 전달
                            onChangeEditorValue={
                              (value) =>
                                setNewsItem((prev) => ({
                                  ...prev,
                                  content: value,
                                })) // 변경된 값 반영
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
              <div className="view-btn">
                <span className="btn custom_s">
                  <button>
                    <Link to="/admin/board/notice" style={{ color: "#fff" }}>
                      목록
                    </Link>
                  </button>
                </span>

                <div className="btn-right">
                  <span className="btn custom_r">
                    <button onClick={handleUpdate}>수정</button>
                  </span>
                  <span className="btn custom_d">
                    <button onClick={handleDelete}>삭제</button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_NView;
